import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_REACT_DSN,
    environment: import.meta.env.MODE,
    tunnel: import.meta.env.VITE_SENTRY_REACT_TUNNEL,
});
